module.exports = __webpack_public_path__ + "static/img/mob-logo.97c65e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mob-logo.svg
// module id = AtOL
// module chunks = 1